import React from 'react'

export const InfoSquareIcon: React.FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6667 3.33333H3.33333V12.6667H12.6667V3.33333ZM2 2V14H14V2H2Z"
        fill="#220C4A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.66683 4.66667L8.66683 5.91667L7.3335 5.91667L7.3335 4.66667L8.66683 4.66667ZM8.66683 7.16667L8.66683 11.3333L7.3335 11.3333L7.3335 7.16667L8.66683 7.16667Z"
        fill="#220C4A"
      />
    </svg>
  )
}

export default InfoSquareIcon
